import * as betprofessor from './RaceCards.styles.betprofessor';
import * as betgalaxy from './RaceCards.styles.betgalaxy';
import * as betroyale from './RaceCards.styles.betroyale';
import * as fiestabet from './RaceCards.styles.fiestabet';
import * as goldenrush from './RaceCards.styles.goldenrush';
import * as juicybet from './RaceCards.styles.juicybet';
import * as puntcity from './RaceCards.styles.puntcity';
import * as puntgenie from './RaceCards.styles.puntgenie';
import * as questbet from './RaceCards.styles.questbet';
import * as sterlingparker from './RaceCards.styles.sterlingparker';
import * as vikingbet from './RaceCards.styles.vikingbet';
import * as volcanobet from './RaceCards.styles.volcanobet';
import * as forsport from './RaceCards.styles.forsport';
import * as junglebet from './RaceCards.styles.junglebet';
import * as betstride from './RaceCards.styles.betstride';
import * as sugarcastle from './RaceCards.styles.sugarcastle';
import * as oldgill from './RaceCards.styles.oldgill';
import * as buffalobet from './RaceCards.styles.buffalobet';
import * as wellbet from './RaceCards.styles.wellbet';
import * as titanbet from './RaceCards.styles.titanbet';
import * as templebet from './RaceCards.styles.templebet';
import * as goldenbet888 from './RaceCards.styles.goldenbet888';
import * as gigabet from './RaceCards.styles.gigabet';
import * as slambet from './RaceCards.styles.slambet';
import * as chromabet from './RaceCards.styles.chromabet';
import * as bet777 from './RaceCards.styles.bet777';
import * as betbetbet from './RaceCards.styles.betbetbet';
import * as hyperbet from './RaceCards.styles.hyperbet';
import * as bet575 from './RaceCards.styles.bet575';
import * as betblast from './RaceCards.styles.betblast';
import * as pyramidbet from './RaceCards.styles.pyramidbet';
import * as magnumbet from './RaceCards.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  oldgill,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  forsport,
  junglebet,
  betstride,
  sugarcastle,
  buffalobet,
  betgalaxy,
  wellbet,
  titanbet,
  templebet,
  goldenbet888,
  gigabet,
  slambet,
  chromabet,
  bet777,
  betbetbet,
  hyperbet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
